import { Outlet, createFileRoute } from "@tanstack/react-router";

/** Layout for an objective. The objective overview lives in the index route
 * (`…o.$objectiveSlug.index.tsx`); the key-result detail renders here via Outlet. */
export const Route = createFileRoute("/_app/plan/o/$objectiveSlug")({
  component: () => <Outlet />,
});
